export default class TwoFactorEnrolmentRequiredError extends Error {
  constructor(
    data = {},
    message = 'Two-step verification must be set up before continuing.',
    code = 423
  ) {
    super(message);
    this.name = this.constructor.name;
    this.data = data;
    this.code = code;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }

  getChannels() {
    return Array.isArray(this.data.channels) ? this.data.channels : [];
  }

  getCode() {
    return this.code;
  }
}
